import { render, staticRenderFns } from "./ProcessParameter.vue?vue&type=template&id=65c7b990"
import script from "./ProcessParameter.vue?vue&type=script&lang=js"
export * from "./ProcessParameter.vue?vue&type=script&lang=js"
import style0 from "./ProcessParameter.vue?vue&type=style&index=0&id=65c7b990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports